// extracted by mini-css-extract-plugin
module.exports = {"container":"register_container__1czVG","logo":"register_logo__1pH5_"};